module.exports = __webpack_public_path__ + "static/media/sacred_geometry.a35a53aa.png";